import React, { FC, useState } from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import { ITitleDesResult } from '@/pages/dashboard/hooks/useTitleDes';

interface ITitleDesProps {
  titleDes: ITitleDesResult[];
  className?: string;
  bubbleProps?: any;
}

// 该组件用于渲染卡片旁边的 information icon 的气泡提示，配合 hooks/useTitleDes.ts 使用
const TitleDes = (props: ITitleDesProps) => {
  const { titleDes, className = 'register-table-tipWidth', bubbleProps = {} } = props;
  const [isHover, setIsHover] = useState(false);

  if (!titleDes || titleDes.length === 0) {
    return null;
  }

  return (
    <Bubble
      className={className}
      dark
      content={
        <>
          {titleDes.map((item: any, index: number) => (
            <p
              key={index}
              dangerouslySetInnerHTML={{
                __html: `
                  ${item?.title ? `${item?.title?.replace(/\\n/g, '<br/>')}<br/>` : ''}
                  ${item.content?.replace(/\\n/g, '<br/>')}
                `
              }}
              style={{
                marginTop: index !== 0 ? '24px' : '0'
              }}
            />
          ))}
        </>
      }
      {...bubbleProps}
    >
      <i
        onMouseOver={() => { setIsHover(true) }}
        onMouseOut={() => { setIsHover(false) }}
        className='register-table-tip'
      >
        <SvgIcon
          type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
          className='register-table-tipicon'
        />
      </i>
    </Bubble>
  );
};

export default TitleDes;
